<a 
  *ngIf="!!url" 
  [routerLink]="url" 
  [queryParams]="queryParams"
  matRipple
  class="unformatted-link mat-ripple shared-sidebar-item"
  [ngClass]="{ selected: isSelected, disabled: isDisabled, child: isChild, 'left-icon-layout': !!leftDefaultIcon || !!leftSelectedIcon }"
  (click)="handleClick($event)"
>
  <nv-icon *ngIf="!!leftDefaultIcon && !isSelected" class="sidebar-item-icon" [name]="leftDefaultIcon"></nv-icon>
  <nv-icon *ngIf="!!leftSelectedIcon && isSelected" class="sidebar-item-icon" [name]="leftSelectedIcon"></nv-icon>
  <span class="sidebar-item-label">{{ label }}</span>
  <nv-icon
    *ngIf="!!rightDefaultIcon && !isSelected"
    class="sidebar-item-dropdown"
    [name]="rightDefaultIcon"
  ></nv-icon>
  <nv-icon
    *ngIf="!!rightSelectedIcon && isSelected"
    class="sidebar-item-dropdown"
    [name]="rightSelectedIcon"
  ></nv-icon>
  <span *ngIf="hasBetaFlag" class="sidebar-item-beta-flag">beta</span>
</a>
<button
  *ngIf="!url"
  matRipple
  class="shared-sidebar-item"
  [ngClass]="{ selected: isSelected, disabled: isDisabled }"
  (click)="handleClick($event)"
>
  <nv-icon *ngIf="!!leftDefaultIcon && !isSelected" class="sidebar-item-icon" [name]="leftDefaultIcon"></nv-icon>
  <nv-icon *ngIf="!!leftSelectedIcon && isSelected" class="sidebar-item-icon" [name]="leftSelectedIcon"></nv-icon>
  <span class="sidebar-item-label">{{ label }}</span>
  <nv-icon *ngIf="rightDefaultIcon && !isSelected" class="sidebar-item-dropdown" [name]="rightDefaultIcon"></nv-icon>
  <nv-icon *ngIf="!!rightSelectedIcon && isSelected" class="sidebar-item-dropdown" [name]="rightSelectedIcon"></nv-icon>
  <span *ngIf="hasBetaFlag" class="sidebar-item-beta-flag">beta</span>
</button>
